<template>
  <div>
    <el-dialog
      :title="popupTitle"
      width="1438px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="page-main">
        <div class="page-r">
          <component :is="`Cont${module}`" :xietongId="xietongId" @success="popupCancel" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ContVerify from './cont-verify/xietong'
export default {
  components: {
    ContVerify
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    xietongId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      selfShow: false,
      module: 'Verify',
      xie_tong_bill_code: '',
      xie_tong_status_str: ''
    }
  },
  computed: {
    maxHeight() {
      let result = 0
      if (this.xietongId) {
        result = `${this.$util.getViewHeight() - 250}px`
      } else {
        result = `${this.$util.getViewHeight() - 380}px`
      }
      return result
    },
    popupTitle() {
      let result = '工程协同'
      if (this.xie_tong_bill_code && this.xie_tong_status_str) {
        result = `${result}(${this.xie_tong_bill_code})-${this.xie_tong_status_str}`
      }
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    if (this.xietongId) this.getDetailData()
  },
  methods: {
    // 获取-详情数据
    getDetailData() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/gongChengXieTong/detail',
        params: {
          id: this.xietongId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data)
          this.xie_tong_bill_code = result.gong_cheng_xie_tong_formData.xie_tong_bill_code
          this.xie_tong_status_str = result.gong_cheng_xie_tong_formData.xie_tong_status_str
        }
      })
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('success')
      this.$emit('update:show', false)
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
  position: relative;
  display: flex;
  height: v-bind(maxHeight);
  padding-bottom: 10px;
  .page-l {
    margin-right: 10px;
  }
  .page-r {
    flex: 1;
  }
}
</style>
